import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// GOOGLE OAUTH
import { GoogleOAuthProvider } from '@react-oauth/google';

// MICROSOFT AUTH
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';

// Google Client ID
const CLIENT_ID_GOOGLE = "651564583600-po6vdvsq01bcisjo895krq65a63pesdf.apps.googleusercontent.com";

// Microsoft config
const msalConfig = {
  auth: {
    clientId: "1fbd5899-0a02-4b83-ab88-c06b11b5c54f",
    authority: "https://login.microsoftonline.com/common",
    redirectUri: "http://localhost:3000",
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  }
};

const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <GoogleOAuthProvider clientId={CLIENT_ID_GOOGLE}>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </GoogleOAuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
